"use client";
import "swiper/css";
import Image from "next/image";
import { GlareCard } from "../ui/glare-card";
import { Swiper, SwiperSlide } from "swiper/react";
import AnimationContainer from "../utils/animation-container";

const products = [
  {
    id: 1,
    title: "خرید یوسی پابجی موبایل",
    image: "/images/pubg.jpg",
    price: "۱،۰۰۰،۰۰۰",
    color: "#CC954A",
  },
  {
    id: 2,
    title: "خرید سی پی کالاف دیوتی",
    image: "/images/callofduty.jpg",
    price: "۵۵۰،۰۰۰",
    color: "#18252B",
  },
  {
    id: 3,
    title: "خرید کوین بازی FIFA 2025",
    image: "/thumbnail/fc25.jpg",
    price: "۸۵۰،۰۰۰",
    color: "#5B7889",
  },
  {
    id: 4,
    title: "خرید گیفت کارت استیم",
    image: "/images/steam.jpg",
    price: "۴۵۰،۰۰۰",
    color: "#161A20",
  },
  {
    id: 5,
    title: "خرید کوین بازی BATTLEFIELD",
    image: "/thumbnail/ezgif-3-d34243e607.webp",
    price: "۸۵۰،۰۰۰",
    color: "#0CCBBF9c",
  },
];

const ShoppingCard = () => {
  return (
    <div className="w-full h-full">
      <AnimationContainer delay={0.5}>
        <div className="mb-3 flex flex-col gap-2">
          <h1 className="font-medium text-[24px]">محصولات ویژه ما</h1>
          <p className="text-[13px] text-gray-400">
            جدیدترین آیتم‌های بازی، گیفت کارت و ارزهای درون‌برنامه‌ای با بهترین قیمت و تحویل آنی
          </p>
        </div>

        <div className="w-full">
          <Swiper
            loop={true}
            spaceBetween={30}
            grabCursor={true}
            breakpoints={{
              0: { slidesPerView: 1 },
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1280: { slidesPerView: 4 },
            }}
          >
            {products.map((product) => (
              <SwiperSlide key={product.id} className="flex justify-center items-center">
                <div
                  className="flex flex-col gap-2 p-4 rounded-xl duration-500 cursor-pointer"
                  style={{
                    background: `linear-gradient(to top, ${product.color} 10%, transparent 85%)`,
                  }}
                >
                  <GlareCard className="rounded-xl" glow={{ enable: false, opacity: 0 }} scale={0.95}>
                    <Image src={product.image} width={400} height={400} alt={product.title} className="rounded-xl" />
                  </GlareCard>

                  <div className="flex flex-col">
                    <p className="text-[15px] font-semibold">{product.title}</p>
                    <div className="w-full flex items-end justify-end gap-1 text-[14px]">
                      <span>{product.price}</span>
                      <p className="text-[12px]">تومان</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </AnimationContainer>
    </div>
  );
};

export default ShoppingCard;
